// Bilder je Sekunde: gezählt je Bild, gemittelt über jeweils eine Sekunde. Der Zähler ist rein
// und getestet; die Anzeige ist ein kleines Feld in der Ecke.

export interface FpsCounter {
  /** Ein Bild zum Zeitpunkt `nowMs`; liefert den Mittelwert, sobald eine Sekunde voll ist, sonst null. */
  frame(nowMs: number): number | null;
}

export function createFpsCounter(): FpsCounter {
  let fensterStart: number | null = null;
  let bilder = 0;
  return {
    frame(nowMs) {
      if (fensterStart === null) {
        fensterStart = nowMs;
        return null;
      }
      bilder++;
      const dauer = nowMs - fensterStart;
      if (dauer < 1000) return null;
      const fps = Math.round((bilder * 1000) / dauer);
      fensterStart = nowMs;
      bilder = 0;
      return fps;
    },
  };
}

export interface FpsDisplay {
  frame(nowMs: number): void;
}

/** Hängt die Anzeige an `parent` und aktualisiert sie einmal je Sekunde. */
export function createFpsDisplay(parent: HTMLElement): FpsDisplay {
  const zaehler = createFpsCounter();
  const feld = document.createElement('div');
  feld.className = 'hud-fps';
  feld.textContent = '– fps';
  parent.append(feld);
  return {
    frame(nowMs) {
      const fps = zaehler.frame(nowMs);
      if (fps !== null) feld.textContent = `${fps} fps`;
    },
  };
}
